module.exports = __webpack_public_path__ + "img/picture_03.3ceb94bc.png";